import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Select, fetchLanguages } from 'wwtc-sdk';
//import * as AWS from 'aws-sdk/global';
import { getRandomID, getMd5 } from './utils';
import './login.css';
import './common/button.css';
import { Cog, Times } from './svg/icons';

function Login() {
    const history = useHistory();
    const [form, setForm] = useState({
        language: null,
        languageAux: null,
        displayName: null,
    });
    const [info, setInfo] = useState({
        loading: false,
        error: null,
        languages: [],
    });
    const [errors, setErrors] = useState([]);
    const [modalSettings, setModalSettings] = useState(false);
    const [roomType, setRoomType] = useState('persistent');

    useEffect(() => {
        fetchLanguages().then((languages) => {
            setInfo({
                ...info,
                languages,
            });
        });
    }, []);

    const handleLanguage = (language, field) => {
        setForm({ ...form, [field]: language });
    };

    const handleGender = (gender) => {
        setForm({ ...form, gender });
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (validateLogin()) {
            const { language, languageAux, displayName } = form;
            const roomName = roomType === 'persistent' ? getMd5(displayName) : getRandomID(6);
            setInfo({
                ...info,
                loading: false,
            });
            history.push(`/app`, {
                userName: displayName,
                room: roomName,
                language: language.value,
                languageAux: languageAux.value,
                roomType,
                apiToken: window.apiToken,
            });
        } else {
            setInfo({
                ...info,
                error: 'Please fill inputs to continue',
            });
        }
    };

    const validateLogin = () => {
        let valid = true;
        let errors = [];
        Object.keys(form).forEach((item) => {
            if (!form[item] || form[item] === '') {
                valid = false;
                errors.push(item);
            }
        });
        setErrors(errors);
        return valid;
    };

    const errorDisplayName = errors.find((item) => item === 'displayName');

    return (
        <div className="wrapper-login">
            <div className="wrapper-content">
                <div className="wrapper-login-modal">
                    <div className="wrapper-logo">
                        <img src={`${process.env.PUBLIC_URL}/logo-login.png`} alt="WWTC" />
                    </div>
                    <form className="form-modal" onSubmit={handleLogin}>
                        <div className="title-welcome">
                            <h2>Virtual Interpreter</h2>
                            <div style={{ position: 'absolute', right: 0, top: 0 }}>
                                <button
                                    className="a-element"
                                    type="button"
                                    onClick={() => setModalSettings(true)}
                                >
                                    <Cog />
                                </button>
                            </div>
                        </div>
                        <div className="wrapper-login-form">
                            <div className="login-inputs">
                                <Select
                                    handleChange={(lng) => handleLanguage(lng, 'language')}
                                    data={info.languages}
                                    value={form.language || ''}
                                    placeholder="Primary language"
                                    showLanguageServices={true}
                                />
                            </div>
                            <div className="login-inputs">
                                <Select
                                    handleChange={(lng) => handleLanguage(lng, 'languageAux')}
                                    data={info.languages}
                                    value={form.languageAux || ''}
                                    placeholder="Secondary language"
                                    showLanguageServices={true}
                                />
                            </div>
                            <div className="login-inputs">
                                <input
                                    className={`Input ${errorDisplayName ? 'Input-error' : ''}`}
                                    type="text"
                                    placeholder="Your Name"
                                    value={form.displayName || ''}
                                    onChange={(e) =>
                                        setForm({ ...form, displayName: e.target.value })
                                    }
                                />
                            </div>
                        </div>
                        <div className="wrapper-button-actions">
                            <button
                                onClick={handleLogin}
                                type="submit"
                                className="Button Button-primary Button-block"
                            >
                                {info.loading ? (
                                    <img
                                        src="https://sdkresources.s3.amazonaws.com/assets/oval.svg"
                                        style={{ width: 14, height: 14 }}
                                        alt="loading"
                                    />
                                ) : (
                                    'connect'
                                )}
                            </button>
                        </div>
                        <div className="error-message">
                            {info.error ? <p>{info.error}</p> : null}
                        </div>
                    </form>
                </div>
                {modalSettings ? (
                    <ModalSettings
                        closeModal={() => setModalSettings(false)}
                        roomType={roomType}
                        setRoomType={setRoomType}
                    />
                ) : null}
            </div>
        </div>
    );
}

const ModalSettings = (props) => {
    const { closeModal, roomType, setRoomType } = props;

    return (
        <div style={stylesWrapper.containerModal}>
            <div style={{ ...stylesWrapper.wrapperModal, height: 200, width: 350 }}>
                <div className="header-container">
                    <div className="header-title">
                        <span>Settings</span>
                    </div>
                    <div className="header-options">
                        <button className="a-element" onClick={closeModal}>
                            <Times />
                        </button>
                    </div>
                </div>
                <div
                    className="body-container"
                    style={{ ...stylesWrapper.bodyModal, textAlign: 'center' }}
                >
                    <p>Room type</p>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                        }}
                    >
                        <div>
                            <input
                                type="radio"
                                id="persistent"
                                name="roomType"
                                value="persistent"
                                checked={roomType === 'persistent'}
                                onChange={(e) => setRoomType(e.target.value)}
                            />
                            <label htmlFor="persistent">Persistent</label>
                        </div>

                        <div>
                            <input
                                type="radio"
                                id="random"
                                name="roomType"
                                value="random"
                                checked={roomType === 'random'}
                                onChange={(e) => setRoomType(e.target.value)}
                            />
                            <label htmlFor="random">Random</label>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 48,
                        }}
                    >
                        <button
                            type="button"
                            className="Button Button-small Button-primary"
                            onClick={closeModal}
                        >
                            save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const stylesWrapper = {
    containerModal: {
        display: 'flex',
        justifyContent: 'center',
        height: 'calc(100vh - 50px)',
        width: '100vw',
        background: 'rgba(1,1,1,0.3)',
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 2000,
    },
    bodyModal: {
        marginTop: 15,
        height: 'calc(100% - 30px)',
        overflow: 'auto',
    },
    wrapperModal: {
        padding: '10px 5px',
        backgroundColor: 'white',
        borderRadius: 5,
        height: '350px',
        top: 'calc(50% - 250px)',
        width: '250px',
        position: 'absolute',
        WebkitBoxShadow: '4px 4px 9px -1px rgba(0,0,0,0.75)',
        MozBoxShadow: '4px 4px 9px -1px rgba(0,0,0,0.75)',
        boxShadow: '4px 4px 9px -1px rgba(0,0,0,0.75)',
    },
};

export default Login;
